// @flow
import React from 'react';
import './LoadingIndicator.css';
import classNames from 'classnames';
import _ from 'lodash/fp';

export type Props = {
  isLoading: boolean,
  isGlobal?: boolean,
  hideSpinner?: boolean,
  progress?: number,
};

const LoadingIndicator = ({isLoading, progress, isGlobal = false, hideSpinner = false}: Props) => (
  <div className={classNames({
    LoadingIndicator: true,
    isLoading,
    isGlobal,
  })}>
    {_.isNumber(progress) &&
      <div className="success progress">
        <div className="progress-meter" style={{width: `${_.toNumber(progress)}%`}}></div>
      </div>
    }
    {!hideSpinner &&
      <div className={classNames({spinner: true, small: _.isNumber(progress)})}>
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    }
  </div>
);

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator/LoadingIndicator.js